module.exports = __webpack_public_path__ + "127ab943dd4ce17b19ee2bf8c06741c6.jpg";